<div class="d-flex justify-content-between align-items-baseline">
  <h4 class="mb-0">{{ 'ZENDR_SENDER_CONFIG' | translate }}</h4>
  <button class="btn btn-default" style="font-size: 20px;" (click)="save()">
    <i ngbTooltip="{{ 'SAVE' | translate }}" class="fas fa-save"></i>
  </button>
</div>
<hr />

@if (loaded) {
  <div class="row" [formGroup]="form">
    <div class="col-12 col-xl-6">
      <h5 class="mb-3">{{ 'SENDER_CONTACT' | translate }}</h5>

      <lib-gung-text-input gungTranslate="CONTACT_NAME" formControlName="contactName"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="CONTACT_COMPANY" formControlName="contactCompany"></lib-gung-text-input>
      <lib-gung-text-input
        gungTranslate="CONTACT_EXTERNAL_CUSTOMER_ID"
        formControlName="contactExternalCustomerId"
      ></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="CONTACT_EMAIL" formControlName="contactEmail"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="CONTACT_PHONE_NUMBER" formControlName="contactPhoneNumber"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="CONTACT_VAT_NUMBER" formControlName="contactVatNumber"></lib-gung-text-input>
    </div>

    <div class="col-12 col-xl-6">
      <h5 class="mb-3">{{ 'SENDER_ADDRESS' | translate }}</h5>

      <lib-gung-text-input gungTranslate="ADDRESS_POSTAL_CODE" formControlName="addressPostalCode"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="ADDRESS_POSTAL_TOWN" formControlName="addressPostalTown"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="ADDRESS_COUNTRY_CODE" formControlName="addressCountryCode"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="ADDRESS_STATE" formControlName="addressState"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="ADDRESS_LINE_1" formControlName="addressLine1"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="ADDRESS_LINE_2" formControlName="addressLine2"></lib-gung-text-input>
      <lib-gung-text-input gungTranslate="ADDRESS_LINE_3" formControlName="addressLine3"></lib-gung-text-input>
    </div>
  </div>
}
